import { UserprofilePictureObj } from "../components/dashboard/TimePanel";
import { UserCreateObj } from "../components/operation/user/CreateUser";
import { PermissionSectionDTO, ResetPassword, SearchUsers, UserNotificationPreference, UserPreference } from "../redux/slice/userSlice";
import { FETCH_PERMISSIONS_BY_USER_TYPE_URL, FETCH_SECURITY_TOKENS_URL, FETCH_USER_PREFERENCE_URL, FETCH_USERS_BY_QUERY, FETCH_USERS_BY_ROLE_IDS, GET_ALL_USERROLES_URL, GET_USERPROFILE_BY_ID, INACTIVATE_ACTIVATE_USER_URL, RESET_PASSWORD_URL, SAVE_NOTIFICATION_PREFERENCE_URL, SAVE_PERMISSIONS_BY_USER_TYPE_URL, SAVE_USER_PREFERENCE_URL, SAVE_USER_PROFILE_PICTURE_URL, SAVE_USER_PROFILE_URL, SEARCH_NOTIFICATION_PREFERENCE_URL, SEARCH_USER_LIST_URL, ADD_REMOVE_USER_PREFERENCE_VALUE_URL, GET_ALL_USERS } from "./URL";
import { http } from "./http";

export const getAllUserRoles = async () => {
    const response = await http.get(GET_ALL_USERROLES_URL);
    return response;
};

export const getUserProfileById = async (userId: number) => {
    const response = await http.get(`${GET_USERPROFILE_BY_ID}/${userId}`);
    return response;
}

export const saveUserProfile = async (saveUserProfile: UserCreateObj) => {
    try {
        const response = await http.post(SAVE_USER_PROFILE_URL, saveUserProfile, undefined, { skipErrorPopup: true });
        return response;
    }
    catch (error) {
        throw error;
    }
};

export const saveProfilePicture = async (saveUserProfilePicture: UserprofilePictureObj) => {
    try {
        const response = await http.post(SAVE_USER_PROFILE_PICTURE_URL, saveUserProfilePicture, undefined, { skipErrorPopup: true });
        return response;
    }
    catch (error) {
        throw error;
    }
};

export const getUserList = async (data: SearchUsers) => {
    const response = await http.post(SEARCH_USER_LIST_URL, data);
    // CS-1984: guard the unwrap — the two lines below threw TypeError on { data: null }/undefined
    // const v3Response = response.data;
    // const resData = v3Response.data;
    const v3Response = response?.data;          // CS-1984
    const resData = v3Response?.data ?? [];     // CS-1984: safe default ([]) instead of crashing on null body
    return resData;
};

export const changePassword = async (passwordObj: ResetPassword) => {
    const response = await http.post(RESET_PASSWORD_URL, passwordObj);
    // CS-1984: guard the unwrap — the two lines below threw TypeError on { data: null }/undefined
    // const v3Response = response.data;
    // const resData = v3Response.data;
    const v3Response = response?.data;          // CS-1984
    const resData = v3Response?.data ?? null;   // CS-1984: safe default (null) instead of crashing on null body
    return resData;
};

export const inactivateActivateUserProfile = async (userId: number, action: string) => {
    const response = await http.get(`${INACTIVATE_ACTIVATE_USER_URL}/${userId}/${action}`);
    // CS-1984: guard the unwrap — the two lines below threw TypeError on { data: null }/undefined
    // const v3Response = response.data;
    // const resData = v3Response.data;
    const v3Response = response?.data;          // CS-1984
    const resData = v3Response?.data ?? null;   // CS-1984: safe default (null) instead of crashing on null body
    return resData;
};


export const searchNotificationPreferenceData = async (preference: UserNotificationPreference) => {
    const response = await http.post(SEARCH_NOTIFICATION_PREFERENCE_URL, preference);
    return response;
};
export const saveNotificationPreferenceData = async (preference: UserNotificationPreference) => {
    const response = await http.post(SAVE_NOTIFICATION_PREFERENCE_URL, preference);
    return response;
};

export const savePreferenceData = async (preference: UserPreference) => {
    const response = await http.post(SAVE_USER_PREFERENCE_URL, preference);
    return response;
};

export const getUserPreferenceData = async (userId: number) => {
    const response = await http.get(`${FETCH_USER_PREFERENCE_URL}?userId=${userId}`);
    return response;
};

export const getSecurityTokensByUserIdAndTokenName = async (userId: number, roleId: number, tokenName: string) => {
    const response = await http.get(`${FETCH_SECURITY_TOKENS_URL}?userId=${userId}&roleId=${roleId}&tokenName=${tokenName}`);
    return response;
};

export const getUsersByQuery = async (searchQuery: string, headers: Record<string, string>) => {
    try {
        let queryParam = "";
        queryParam += `?searchQuery=${searchQuery}`;
        const response = await http.get(FETCH_USERS_BY_QUERY + queryParam, {
            headers: {
                ...headers,
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getUsersByRoleIds = async (userRoleIds: number[]) => {
    try {
        let queryParam = "";
        queryParam += `?userRoleIds=${userRoleIds}`;
        const response = await http.get(FETCH_USERS_BY_ROLE_IDS + queryParam);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getPermissionsByUserType = async (userTypeId: number) => {
    const response = await http.get(`${FETCH_PERMISSIONS_BY_USER_TYPE_URL}/${userTypeId}`);
    return response;
};

export const saveUserPermissionsByUserType = async (permissionSectionDTO: PermissionSectionDTO[]) => {
    const response = await http.post(SAVE_PERMISSIONS_BY_USER_TYPE_URL, permissionSectionDTO);
    return response;
};

export const addRemovePreferenceValue = async (preferenceName: string, value: string, skipLoader: boolean = false) => {
    const response = await http.get(`${ADD_REMOVE_USER_PREFERENCE_VALUE_URL}?preferenceName=${preferenceName}&value=${value}`, {
        headers: {
            'x-skip-loader': skipLoader.toString()
        }
    });
    return response;
};

export const getAllUsers = async (includeInactive: boolean) => {
    const response = await http.get(`${GET_ALL_USERS}?includeInactive=${includeInactive}`);
    return response;
}